import script from "./Photos.vue?vue&type=script&setup=true&lang=js"
export * from "./Photos.vue?vue&type=script&setup=true&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=0f63f6c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_typescript@5.6.2__webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f63f6c6"]])

export default __exports__